'use client';
import dynamic from 'next/dynamic';
import type {SVGProps} from 'react';
import {createContext, useContext} from 'react';

import type {IconVariants} from '@/enums/Icon';
import {LoaderVariants} from '@/enums/Icon';

import Skeleton from './Skeleton';
import Spinner from './Spinner';

export interface IconProps extends LoaderValueType, SVGProps<SVGSVGElement> {
  name?: string;
  alt?: string;
  isLocal?: boolean;
}
type LoaderValueType = {
  width?: number | string;
  height?: number | string;
  variant?: IconVariants;
  spinnerStyles?: string;
  loaderVariant?: LoaderVariants;
};
const LoaderValueContext = createContext({} as LoaderValueType);

export function Loader() {
  const {loaderVariant, spinnerStyles, width, height, variant} = useContext(LoaderValueContext);
  return loaderVariant === LoaderVariants.SKELETON ? (
    <Skeleton width={Number(width) || 16} height={Number(height) || 16} variant={variant} />
  ) : loaderVariant === LoaderVariants.SPINNER ? (
    <Spinner variant="xs" spinnerStyles={spinnerStyles} />
  ) : (
    <></>
  );
}

const LoadSVG = dynamic(() => import('./SvgLoader'), {
  ssr: false,
  loading: () => <Loader />,
});

export default function Icon({name, loaderVariant = LoaderVariants.SKELETON, spinnerStyles, ...rest}: IconProps) {
  if (!name) {
    return <></>;
  }
  return (
    <>
      <LoaderValueContext.Provider value={{loaderVariant, spinnerStyles, width: rest.width, height: rest.height, variant: rest.variant}}>
        <LoadSVG name={name} {...rest} />
      </LoaderValueContext.Provider>
    </>
  );
}
